import { CurrentPrice } from '../currentPrice';
import { ParsedNumber } from '../parsed/parsedNumber';
import { BaseProduct } from './baseProduct';
import { PriceDetails } from './priceDetails';
import { DisableAddLocalKey } from './uiProduct';
import { z } from 'zod';

export const ProductItem = z.object({
    bundles: BaseProduct.array().nullish(),
    flags: z.string().array().nullish(),
    itemId: z.string().nullish(),
    rootItemId: z.string().nullish(),
    price: z.union([z.number(), CurrentPrice]).nullish(),
    priceDetails: PriceDetails.nullish(),
    product: BaseProduct.nullish(),
    disableAddLocalKey: DisableAddLocalKey.nullish(),
    scores: z
        .object({
            store: ParsedNumber.nullish(),
            global: ParsedNumber.nullish(),
        })
        .nullish(),
});
export type ProductItem = z.infer<typeof ProductItem>;
